/**
 * NOLAS 2026, (c) Mikaël FOURNY.
 * src/i18n/fr.reseaux.ts
 *
 * Messages du bloc « Suivez l'événement » (comptes officiels) et des deux
 * réglages correspondants au back-office. Fusionné dans fr.ts.
 *
 * Mikael - chef de projet - 2026-09-25
 */
export const messagesReseauxFr: Record<string, string> = {
  'reseaux.titre': 'Suivez {eventTypeDef} sur les réseaux',
  'reseaux.instagram': 'Instagram',
  'reseaux.linkedin': 'LinkedIn',

  'settingsAdmin.section.social': 'Réseaux sociaux',
  'settingsAdmin.social.instagram.label': 'Compte Instagram officiel',
  'settingsAdmin.social.instagram.help':
    'Adresse complète du compte, par exemple https://www.instagram.com/mon_compte/. Laissez vide s’il n’y a pas de compte : aucun lien ne s’affiche alors dans l’application. Seules les adresses en https sont acceptées.',
  'settingsAdmin.social.linkedin.label': 'Page LinkedIn officielle',
  'settingsAdmin.social.linkedin.help':
    'Adresse complète de la PAGE, par exemple https://www.linkedin.com/company/ma-page/. Ce n’est pas le profil personnel d’une personne de l’organisation. Laissez vide s’il n’y a pas de page.',
};
